// extracted by mini-css-extract-plugin
export default {"basketWithObject":"BasketManager_basketWithObject__YXHy-","removeButton":"BasketManager_removeButton__MeLRu","existingBaskets":"BasketManager_existingBaskets__8w9yu"};